import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./es.json";

i18n.use(initReactI18next).init({
  fallbackLng: "es",
  resources: {
    es: es,
  },
});

export default i18n;